export const createQueryString = (parameters: { [key: string]: string }): string => Object
  .entries(parameters)
  .filter(([, value]: [string, string]): boolean => !!value)
  .map(([key, value]: [string, string]): string => `${key}=${value}`)
  .join('&');
